<template>
    <li class="nav-item dropdown" :class="{ show: showDropdownMenu }">
        <a class="navbar-nav-link dropdown-toggle caret-0" :aria-expanded="String(showDropdownMenu)" href="#" @click.prevent="toggleDropdown">
            <i class="icon-lifebuoy"></i>
            <span class="ml-2">{{ $t ? $t('labels.support') : translate('labels.support') }}</span>
        </a>
        <div class="dropdown-menu dropdown-content wmin-md-200" :class="{ show: showDropdownMenu }">
            <div class="dropdown-content-body">
                <ul class="media-list">
                    <li class="media align-items-center">
                        <div class="mr-2">
                            <img src="/img/social-media/whatsapp.png" width="32" height="32" alt="WhatsApp">
                        </div>
                        <div class="media-body d-flex align-items-center media-body-height">
                            <a href="https://wa.me/380995595240" target="_blank">WhatsApp</a>
                        </div>
                    </li>
                    <li class="media align-items-center">
                        <div class="mr-2">
                            <img src="/img/social-media/telegram.png" width="32" height="32" alt="Telegram">
                        </div>
                        <div class="media-body d-flex align-items-center media-body-height">
                            <a href="https://t.me/fasunoksupport_bot" target="_blank">Telegram</a>
                        </div>
                    </li>
                    <li class="media align-items-center">
                        <div class="mr-2">
                            <img src="/img/social-media/viber.png" width="32" height="32" alt="Viber">
                        </div>
                        <div class="media-body d-flex align-items-center media-body-height">
                            <a href="viber://pa?chatURI=fasunoksupport" target="_blank">Viber</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </li>
</template>
<script>
export default {
    name: "ContactInformationTab",
    data() {
        return {
            showDropdownMenu: false
        }
    },
    methods: {
        toggleDropdown() {
            this.showDropdownMenu = !this.showDropdownMenu
        },
        handleOutsideClick(event) {
            if (!this.$el.contains(event.target)) {
                this.showDropdownMenu = false
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideClick)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick)
    }
}
</script>
